import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';
import map from 'lodash/map';
import forEach from 'lodash/forEach';
import includes from 'lodash/includes';
import Alert from '~/components/alert/alert';
import uniqueId from 'lodash/uniqueId';

const IMPORTED = "imported";
const PENDING_VALIDATION = "pending_validation";
const PENDING_IMPORT = "pending_import";
const IMPORTING = "importing";
const IMPORT_ERROR = 'import_error';
const VALIDATED = "validated";
const VALIDATE_ERROR = "validate_error";
const VALIDATING = "validating";

export default class Importer extends Component {
  static propTypes = {
    appState: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)

    this.IVTypes = {
      opening: 1,
      actual_qty: 2,
      var_qty: 3,
      cost_adjust: 4
    };

    this.state = {
      type: this.IVTypes.opening
    }
  }

  componentWillMount(){
    this.props.actions.importInit()
  }

  componentWillReceiveProps(nextProps) {
    let sourceDate = nextProps.appState.importerStatus.inventory_variance_import ? 
      nextProps.appState.importerStatus.inventory_variance_import
      :
      nextProps.appState.importerStatus
    let status = sourceDate.status || '';
    let allow_import = sourceDate.allow_import || '';
    let inventory_import_id = sourceDate.id || '';

    if (status === VALIDATING || status === PENDING_VALIDATION || status === VALIDATED && allow_import === false) {
      this.startPoll(inventory_import_id);
    } else if (status === PENDING_IMPORT || status === IMPORTING) {
      this.startPoll(inventory_import_id);
    }
  }

  validateFileName(files) {
    //validating the file name
    let isValid = true;
    forEach(files, (val, key) => {
      if (!val.dir && !includes(val.name, 'png') && !includes(val.name, 'jpg')) {
        isValid = false;
      }
    });
    return isValid;
  }

  handleChange(event) {
    let type = event.target.value
    this.setState({ type })
  }

  handleFile(e) {
    let self = this;
    let { params, actions } = this.props;
    let { type } = this.state
    let { store_id } = params;
    let reader = new FileReader();

    let file = self.refs.uploadCSV.files[0];

    reader.onload = function (upload) {

      let data = new FormData();
      data.append('inventory_variance_import[csv]', file);
      data.append('type_id', type);
      actions.validateImportIV(store_id, data);

    };
    reader.readAsText(file);
  }

  handleSubmit(e) {
    e.preventDefault();
  }

  startPoll(inventory_import_id) {
    let { store_id } = this.props.params;
    let { actions } = this.props;
    this.timeout = setTimeout(() => actions.getImportIV(store_id, inventory_import_id), 3000);
  }

  startImport() {
    let { store_id } = this.props.params;
    let id = this.props.appState.importerStatus.inventory_variance_import.id;
    this.props.actions.postImportIV(store_id, id)
    this.timeint = setTimeout(() => this.props.actions.getImportIV(store_id, id), 3000);
  }

  render() {
    let { appState, params } = this.props;
    let validate_msg = '';
    let warning_msg = '';
    let error_msg = '';
    let disableImport = true;
    let isShowUploadCSVForm = true;
    let progress_rate = 0;
    const { type } = this.state
    let sourceDate = appState.importerStatus.inventory_variance_import ? 
      appState.importerStatus.inventory_variance_import
      :
      appState.importerStatus

    let backPath = `/v2/${params.store_id}/inventory-variance`;


    switch (sourceDate.status) {
      case IMPORTED:
        validate_msg = 'Import Success';
        progress_rate = 100;
        isShowUploadCSVForm = true;
        break;

      case VALIDATING:
      case PENDING_VALIDATION:
        validate_msg = 'Please wait, we are validating your data';
        progress_rate = parseFloat(sourceDate.validation_progress_rate || 0) * 100;
        isShowUploadCSVForm = false;
        break;

      case IMPORTING:
      case PENDING_IMPORT:
        validate_msg = 'Please wait, we are importing your data';
        progress_rate = parseFloat(sourceDate.import_progress_rate || 0) * 100;
        isShowUploadCSVForm = false;
        break;

      case IMPORT_ERROR:
        warning_msg = map(sourceDate.humanize_validation_warnings, (items, key) => {
          return (
            <table key={uniqueId()} className="table">
              <thead>
              <tr>
                <th>Row</th>
                <th>warning message</th>
              </tr>
              </thead>
              <tbody>
              {map(items, (item) => {
                return <tr key={uniqueId()}><td>{parseInt(key)}</td><td> {item}</td></tr>;
              })}
              </tbody>
            </table>
          );
        });

        error_msg = map(sourceDate.humanize_validation_errors, (items, key) => {
          return (
            <table key={uniqueId()} className="table">
              <thead>
              <tr>
                <th>Row</th>
                <th>Error message</th>
              </tr>
              </thead>
              <tbody>
              {map(items, (item) => {
                return <tr key={uniqueId()}><td>{parseInt(key)}</td><td> {item}</td></tr>;
              })}
              </tbody>
            </table>
          );
        });

        if (!error_msg.length && !warning_msg.length) {
          validate_msg = 'Import Error &  Please check file';
        }
        isShowUploadCSVForm = true;
        disableImport = true;
        progress_rate = 100;
        break;

      case VALIDATED:
      case VALIDATE_ERROR:

        warning_msg = map(sourceDate.humanize_validation_warnings, (items, key) => {
          return (
            <table key={uniqueId()} className="table">
              <thead>
                <tr>
                  <th>Row</th>
                  <th>warning message</th>
                </tr>
              </thead>
              <tbody>
                {map(items, (item) => {
                  return <tr key={uniqueId()}><td>{parseInt(key)}</td><td> {item}</td></tr>;
                })}
              </tbody>
            </table>
          );
        });

        error_msg = map(sourceDate.humanize_validation_errors, (items, key) => {

          return (
            <table key={uniqueId()} className="table">
              <thead>
                <tr>
                  <th>Row</th>
                  <th>Error message</th>
                </tr>
              </thead>
              <tbody>
                {map(items, (item) => {
                  return <tr key={uniqueId()}><td>{parseInt(key)}</td><td> {item}</td></tr>;
                })}
              </tbody>
            </table>
          );
        });

        if (!error_msg.length && !warning_msg.length) {
          validate_msg = 'Validate Success & Ready to importing';
        }


        isShowUploadCSVForm = true;


        disableImport = error_msg.length ? true : false;
        progress_rate = 100;
        break;
    }

    return (
      <div className="main-content">
        <header className="main-content-header columns">
          <h1 className="main-content-title columns-main">Inventory</h1>
          <div>
            <Link to={backPath} className="btn btn-secondary btn-sm">Cancel</Link> &nbsp;
            <button disabled={disableImport} onClick={this.startImport.bind(this)} className="btn btn-primary btn-sm">Import</button>
          </div>
        </header>
        <div className="main-content-section">
          <h2>Import Inventory Variance</h2>
          <p><b>1.You can download this Inventory Variance templates to get started:</b></p>
          <ul style={{ listStyle: 'none', margin: "0 0 10px 0", padding: 0 }}>
            <li><a href={require('./samples/Opening.csv')}>Opening CSV</a></li>
            <li><a href={require('./samples/AdjustmentbyActualQty.csv')}>Adjustment by Actual Qty CSV</a></li>
            <li><a href={require('./samples/AdjustmentbyVarianceQty.csv')}>Adjustment by Variance Qty CSV</a></li>
            <li><a href={require('./samples/CostAdjustment.csv')}>Cost Adjustment CSV</a></li>
          </ul>
          <p>Tips: To make sure you entered the correct Product name or UPC or SKU, you can <a>Export Sliplified Inventory Report</a> with the comespodeling columns as your Inventory Variance Template</p>
        </div>
        <div className="main-content-section">
          <h3>Step 1. Select Inventory Variance type</h3>
          <div className="form-group">
            <select selected={type} onChange={this.handleChange}>
              <option value={this.IVTypes.opening}>Opening</option>
              <option value={this.IVTypes.actual_qty}>Adjustment by Actual QTY</option>
              <option value={this.IVTypes.var_qty}>Adjustment by Variance QTY</option>
              <option value={this.IVTypes.cost_adjust}>Cost Adjustment</option>
            </select>
          </div>
        </div>
        <div className="main-content-section">
          <h3>Step 2. Select File</h3>
          <progress className="progress" value={progress_rate} max="100"></progress>
          <p>Inventory Variance file</p>
          {
            isShowUploadCSVForm ? (
              <form ref="uploadCSVForm" onSubmit={this.handleSubmit} encType="multipart/form-data">
                <p><input accept=".csv,.txt" ref="uploadCSV" type="file" onChange={this.handleFile.bind(this)} /></p>
              </form>
            ) : null
          }
          <div>

            {
              validate_msg ? (
                <Alert style="info"> <p>{validate_msg}</p> </Alert>
              ) : null
            }
            {
              warning_msg && warning_msg.length > 0 ? (
                <Alert style="warning"> {warning_msg} </Alert>
              ) : null
            }
            {
              error_msg && error_msg.length > 0 ? (
                <Alert style="danger"> {error_msg} </Alert>
              ) : null
            }

          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/pages/inventory-variance/Importer.js
 **/